import axios from "axios";
import {setupCache} from "axios-cache-adapter";
import {URL_TEMPLATES as URL} from "src/urlTemplates";
import _ from "lodash";

const hostname = window.location.hostname;
const API_URL =
    process.env.NODE_ENV === "development" ? process.env.REACT_APP_MANTIS_API_BASEURL : "https://" + hostname + "/api";
const REQUESTS_DELAY = process.env.NODE_ENV === "development" ? process.env.REACT_APP_MANTIS_REQUESTS_DELAY_MS : 0;

const cache = setupCache({
    maxAge: 3 * 60 * 1000, // 3 minutes
    limit: 15, // max number of elements
    exclude: {
        methods: ["post", "patch", "put", "delete"]
    },
    key: req => req.url,
    invalidate: async (config, request) => {
        if (request.url.includes("/auth") || config.exclude.methods.includes(request.method.toLowerCase())) {
            await config.store.clear();
        }
    }
});

const axiosInstance = axios.create({
    baseURL: API_URL,
    withCredentials: true,
    adapter: cache.adapter
});

//request interceptor - delay on development
axiosInstance.interceptors.request.use(
    config => {
        return new Promise(resolve => setTimeout(() => resolve(config), REQUESTS_DELAY));
    },
    error => error
);

// Response interceptor for API calls
axiosInstance.interceptors.response.use(
    response => {
        return response;
    },
    async error => {
        const refreshExcludedUrls = ["/auth", "/auth/refresh", "/auth/password", "/recaptcha"];
        if (error.response.status === 401 && _.indexOf(refreshExcludedUrls, error.config.url) === -1) {
            const originalRequest = error.config;
            try {
                await axiosInstance.get("/auth/refresh");
                return axiosInstance(originalRequest);
            } catch (refreshError) {
                window.location.replace(URL.LOGIN);
            }
        }

        return Promise.reject(parseError(error));
    }
);

export {axiosInstance};

const parseError = error => {
    let message = "Something went wrong";
    let status = 500;
    let errors = [];

    if (error.response && error.response.data) {
        let data = error.response.data;
        message = data.message ? data.message : message;
        if (data.errors && data.errors.length > 0) {
            message += " (" + data.errors.map(e => " " + e).toString() + " )";
            errors = data.errors;
        }
    }

    if (error.response && error.response.status) {
        status = error.response.status;
    }

    return {status, message, errors};
};
